import { GetStaticProps } from 'next'

import initApollo, { API } from '../../api'

import { GUIDES } from './queries'

export type Props = { guides: NonNullable<API.GuidesHome['libraryGuides']>['nodes'] }

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.GuidesHome>({
    query: GUIDES,
  })

  return {
    props: {
      guides: data.libraryGuides?.nodes || [],
    },
  }
}
